import { type MenuElement } from '@Hooks/Navigation/types';
import {
    IconChecklist,
    IconDeviceDesktopAnalytics,
    IconFile,
    IconFileExport,
    IconListNumbers,
    IconMail,
    IconRoute,
    IconUserCog,
} from '@tabler/icons-react';
import { Permission } from '@Constants/Permission.g';

export const settingsMenuElements: MenuElement[] = [
    {
        kind: 'group',
        name: 'Counters',
        label: 'Zähler',
        icon: IconDeviceDesktopAnalytics,
        targets: [
            {
                link: '/settings/counters/orders',
                label: 'Aufträge',
                permissions: [Permission.AuftragsbearbeitungCountersRead],
            },
            {
                link: '/settings/counters/billing',
                label: 'Rechnungen',
                permissions: [Permission.BillingCountersRead],
            },
            {
                link: '/settings/counters/stammdaten',
                label: 'Stammdaten',
                permissions: [Permission.StammdatenCountersRead],
            },
            {
                link: '/settings/counters/exports',
                label: 'Exporte',
                permissions: [Permission.DocumentsDynamicExportRunRead],
            },
        ],
    },
    {
        kind: 'group',
        name: 'Documents',
        label: 'Dokumente',
        icon: IconFile,
        targets: [{ link: '/settings/documents', label: 'Ausdrucke', permissions: [Permission.DocumentsDocumentRead] }],
    },
    {
        kind: 'group',
        name: 'Mailing',
        label: 'Emailversand',
        icon: IconMail,
        targets: [
            { link: '/settings/mailing/email_status', label: 'Versand-Status', permissions: [] },
            {
                link: '/settings/mailing/mandant',
                label: 'Email-Vorlagen',
                permissions: ['Mailing.MandantScopedSettings.Read'],
            },
        ],
    },
    {
        kind: 'group',
        name: 'Export',
        label: 'Export',
        icon: IconFileExport,
        targets: [
            { link: '/settings/exports', label: 'Definitionen', permissions: [] },
            {
                link: '/settings/export_runs',
                label: 'Läufe',
                permissions: ['Documents.DynamicExportRun.Read'],
            },
        ],
    },
    {
        kind: 'group',
        name: 'Rulesets',
        label: 'Prüfkriterien',
        icon: IconChecklist,
        targets: [
            {
                link: '/settings/rulesets/orders',
                label: 'Aufträge',
                permissions: [Permission.AuftragsbearbeitungRulesetsRead],
                featureFlag: 'AI_FEATURES',
            },
            {
                link: '/settings/rulesets/stammdaten',
                label: 'Stammdaten',
                permissions: [Permission.StammdatenRulesetsRead],
                featureFlag: 'AI_FEATURES',
            },
        ],
    },
    {
        kind: 'group',
        name: 'WorkflowDefinitions',
        label: 'Workflow-Definitionen',
        icon: IconRoute,
        targets: [
            {
                link: '/settings/workflow_definitions',
                label: 'Definitionen',
                permissions: [Permission.AgenticOrchestratorWorkflowDefinitionsRead],
                featureFlag: 'AI_FEATURES',
            },
            {
                link: '/settings/workflow_runs',
                label: 'Workflow-Läufe',
                permissions: [Permission.AgenticOrchestratorWorkflowRunsRead],
                featureFlag: 'AI_FEATURES',
            },
        ],
    },
    {
        kind: 'group',
        name: 'Logs',
        label: 'Logs',
        icon: IconListNumbers,
        targets: [
            {
                link: '/settings/action_event_logs',
                label: 'Action Logs',
                permissions: [Permission.AuditingActionEventLogsRead],
                featureFlag: 'ACTION_EVENT_LOGS',
            },
            {
                link: '/settings/command_audit_logs',
                label: 'Command Logs',
                permissions: [Permission.AuditingCommandAuditLogsRead],
                featureFlag: 'ACTION_EVENT_LOGS',
            },
        ],
    },
];

export const profileMenuElements: MenuElement[] = [
    {
        kind: 'group',
        name: 'PersonalData',
        label: 'Profildaten',
        icon: IconUserCog,
        targets: [{ link: '/profile/me', label: 'Profildaten', permissions: [] }],
    },
];
